import { enableImageObj } from "./global-variable"

export function dynamciServiceLiList(ser:any){
    let serListCls = enableImageObj.enableImage ? 'inner-list-item' :  '';
    let linkTarget = ser.openNewTab ? "target='_blank'" : "";
    return `<li class="${serListCls}"><a class="dropdown-item arrow-right-link" href="${ser.link}" ${linkTarget}>${ser.name}</a></li>`
}